export default __webpack_public_path__ + "media/video_home_img.6727dfb8.jpg";